import { useEffect, useState } from "react";
import { api, API } from "@/lib/api";
import { PageHeader, KpiCard } from "@/components/shared/Common";
import { Button } from "@/components/ui/button";
import { CheckCircle, XCircle, Gauge, DownloadSimple, FileCsv } from "@phosphor-icons/react";

export default function Reports() {
  const [sla, setSla] = useState(null);
  useEffect(() => { api.get("/reports/sla").then(r => setSla(r.data)); }, []);

  const REPORTS = [
    { key: "cases", label: "Cases export", desc: "All cases with status, assignee, priority" },
    { key: "employees", label: "Workforce export", desc: "Employee capacity, performance and workload" },
  ];

  return (
    <div>
      <PageHeader title="Reports" subtitle="SLA, productivity, capacity, and quality reports" />

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
        <KpiCard label="Completed" value={sla?.total ?? "—"} sub="Cases" icon={CheckCircle} accent="text-emerald-500" />
        <KpiCard label="SLA met" value={sla?.met ?? "—"} sub="On-time" icon={Gauge} />
        <KpiCard label="Breached" value={sla?.breached ?? "—"} sub="Missed SLA" icon={XCircle} accent="text-red-500" />
        <KpiCard label="Compliance" value={`${sla?.compliance ?? 0}%`} sub="Success rate" icon={Gauge} />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {REPORTS.map(r => (
          <div key={r.key} className="border rounded-md bg-card p-6">
            <div className="flex items-center gap-3 mb-2">
              <FileCsv size={20} className="text-primary" weight="fill" />
              <div>
                <div className="font-semibold">{r.label}</div>
                <div className="text-xs text-muted-foreground">{r.desc}</div>
              </div>
            </div>
            <Button data-testid={`report-${r.key}-btn`} variant="outline" className="mt-3" onClick={() => window.open(`${API}/reports/export?type=${r.key}`, "_blank")}>
              <DownloadSimple size={14} className="mr-1" /> Download CSV
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
}
